import Phaser from 'phaser';
import { STATE_LOCATION } from '../constants/AppConstants';
import ScreenContainer from '../display/ui/ScreenContainer';
import LoadDisplay from '../display/ui/LoadDisplay';
import { UnloadAssetPack } from '../../utils/AssetpackUnloader';

export default class LocationLoader extends Phaser.State {
  init({ locationid }) {
    this.locationid = locationid;
  }
  preload() {
    // ditch out last assets
    UnloadAssetPack(this.game, LocationLoader.PreviousAssetPack);
    // store everything in a container, it will reposition for screen
    this.container = new ScreenContainer(this.game, {
      background: 'background_generic',
      overlay: true,
    });
    this.game.add.existing(this.container);

    this.loadDisplay = new LoadDisplay(this.game, true);
    this.loadDisplay.x = this.game.defaultWidth * 0.5 - this.loadDisplay.width * 0.5;
    this.loadDisplay.y = this.game.defaultHeight * 0.5 - this.loadDisplay.height * 0.5;
    this.container.add(this.loadDisplay);

    this.game.load.baseURL = './assets/locations/';
    this.game.load.crossOrigin = 'anonymous';
    this.game.load.pack('general', 'assetpack.json', null, this);
    this.game.load.pack(this.locationid, 'assetpack.json', null, this);
    this.game.load.json('locationassets', 'assetpack.json', null, this);

    this.game.load.onFileComplete.add(this.fileComplete, this);
  }

  create() {
    LocationLoader.PreviousAssetPack = this.game.cache.getJSON('locationassets', true);
    this.game.state.start(STATE_LOCATION, true, false, { locationid: this.locationid });
  }

  fileComplete(progress, cacheKey, success, totalLoaded, totalFiles) {
    this.loadDisplay.progress = progress;
  }

  update() {}

  shutdown() {
    this.game.load.onFileComplete.remove(this.fileComplete, this);
    this.loadDisplay.destroy();
    this.container.destroy();
    this.container = null;
    this.loadDisplay = null;
  }
}

LocationLoader.PreviousAssetPack = {};



// WEBPACK FOOTER //
// ./js/app/states/LocationLoader.js